<template>
  <div id="loanFollowup">
    <loading v-if="loadingRender"></loading>
    <panel
      class="no-print"
      :Title="
        $GetIsAnbohSaz() == 'false'
          ? 'پیگیری درخواست‌های وام'
          : 'پیگیری درخواست‌های واحد'
      "
      :Des="
        $GetIsAnbohSaz() == 'false'
          ? 'از طریق این فرم می‌توانید وضعیت درخواست‌های وام خود را پیگیری کنید'
          : 'از طریق این فرم می‌توانید وضعیت درخواست‌های واحد خود را پیگیری کنید'
      "
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <net-pa-card class="no-print">
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-clipboard-list"></i>
          {{
            $GetIsAnbohSaz() == "false"
              ? "پیگیری درخواست‌های وام"
              : "پیگیری درخواست‌های واحد"
          }}
        </h6>
      </template>
      <template slot="content">
      <div class="loan-followup-content py-1 px-0" :key="Render">
        <div
          v-if="NeedVamList.length > 0 && !loadingRender"
          class="loan-followup-list"
        >
          <article
            v-for="(item, index) in NeedVamList"
            :key="index"
            class="loan-followup-card"
            :class="statusClass(item)"
          >
            <header class="loan-followup-card__top">
              <div class="loan-followup-card__tracking">
                <span class="loan-followup-card__tracking-label"
                  >کد رهگیری</span
                >
                <span class="loan-followup-card__tracking-code">{{
                  item.codeRahgiri
                }}</span>
              </div>
              <div class="loan-followup-card__status">
                <template
                  v-if="
                    $session.get('CustCode') != '932' &&
                    $session.get('CustCode') != '8002'
                  "
                >
                  <span
                    v-if="item.isModirTaeed == 0"
                    class="loan-followup-badge loan-followup-badge--warning"
                  >
                    <i class="far fa-hourglass" aria-hidden="true"></i>
                    در حال بررسی
                  </span>
                  <span
                    v-else-if="item.isModirTaeed == 1"
                    class="loan-followup-badge loan-followup-badge--success"
                  >
                    <i class="fas fa-check" aria-hidden="true"></i>
                    تایید شده
                  </span>
                  <span
                    v-else-if="item.isModirTaeed == 2"
                    class="loan-followup-badge loan-followup-badge--danger"
                  >
                    <i class="fas fa-times" aria-hidden="true"></i>
                    رد شده
                  </span>
                </template>
                <span
                  v-else
                  class="loan-followup-badge loan-followup-badge--info"
                >
                  {{ item.wwwtblComboIdVaziyatGrp312Name }}
                </span>
              </div>
            </header>

            <div class="loan-followup-card__body">
              <div class="loan-followup-card__type">
                <span class="loan-followup-card__eyebrow">
                  {{
                    $GetIsAnbohSaz() == "false"
                      ? "نوع تسهیلات"
                      : "نوع قرارداد"
                  }}
                </span>
                <h6 class="loan-followup-card__title">{{ item.desNoe }}</h6>
              </div>

              <div class="loan-followup-stats">
                <div class="loan-followup-stat">
                  <span class="loan-followup-stat__label">
                    {{
                      $GetIsAnbohSaz() == "false"
                        ? "مبلغ تسهیلات"
                        : "مبلغ قرارداد"
                    }}
                  </span>
                  <span class="loan-followup-stat__value" dir="ltr">
                    {{ $Comma3ragham(item.mablagh) }}
                    <small>{{ $GetVahedPool() }}</small>
                  </span>
                </div>
                <div class="loan-followup-stat">
                  <span class="loan-followup-stat__label">مدت باز پرداخت</span>
                  <span class="loan-followup-stat__value">
                    {{ item.tedadGhest }} قسط
                  </span>
                </div>
                <div class="loan-followup-stat">
                  <span class="loan-followup-stat__label">تاریخ درخواست</span>
                  <span class="loan-followup-stat__value" dir="ltr">{{
                    item.requestTarix
                  }}</span>
                </div>
                <div
                  v-if="
                    item.sepordeTime != null &&
                    item.sepordeTime != 0 &&
                    item.sepordeTime > 0
                  "
                  class="loan-followup-stat"
                >
                  <span class="loan-followup-stat__label"
                    >مدت سپرده‌گذاری</span
                  >
                  <span class="loan-followup-stat__value">
                    {{ item.sepordeTime }} ماه
                  </span>
                </div>
              </div>
            </div>

            <button
              v-if="hasExpandableDetails(item)"
              type="button"
              class="loan-followup-toggle-btn"
              :aria-expanded="isExpanded(index) ? 'true' : 'false'"
              @click="toggleDetails(index)"
            >
              {{ isExpanded(index) ? "بستن جزئیات" : "مشاهده جزئیات" }}
              <i
                class="fas"
                :class="isExpanded(index) ? 'fa-chevron-up' : 'fa-chevron-down'"
                aria-hidden="true"
              ></i>
            </button>

            <div v-show="isExpanded(index)" class="loan-followup-details">
              <section
                v-if="
                  $session.get('CustCode') != 932 &&
                  getZamenEntries(item).length > 0
                "
                class="loan-followup-section"
              >
                <h6 class="loan-followup-section__title">
                  <i class="fas fa-user-friends" aria-hidden="true"></i>
                  ضامنین
                </h6>
                <ul class="loan-followup-zamen-list">
                  <li
                    v-for="zamen in getZamenEntries(item)"
                    :key="zamen.num"
                    class="loan-followup-zamen-row"
                  >
                    <span class="loan-followup-zamen-row__badge">{{
                      zamen.num
                    }}</span>
                    <span
                      class="loan-followup-zamen-row__name"
                      :class="{
                        'loan-followup-zamen-row__name--muted': zamen.isEmpty,
                      }"
                    >
                      {{ zamen.isEmpty ? "اطلاعاتی ثبت نشده" : zamen.name }}
                    </span>
                    <span
                      v-if="zamen.isEmpty"
                      class="loan-followup-zamen-row__muted"
                      >—</span
                    >
                    <span
                      v-else-if="zamen.status == 0"
                      class="loan-followup-badge loan-followup-badge--warning"
                    >
                      <i class="far fa-hourglass" aria-hidden="true"></i>
                      در حال بررسی
                    </span>
                    <span
                      v-else-if="zamen.status == 1"
                      class="loan-followup-badge loan-followup-badge--success"
                    >
                      <i class="fas fa-check" aria-hidden="true"></i>
                      تایید شده
                    </span>
                    <span
                      v-else-if="zamen.status == 2"
                      class="loan-followup-badge loan-followup-badge--danger"
                    >
                      <i class="fas fa-times" aria-hidden="true"></i>
                      رد شده
                    </span>
                    <button
                      v-if="
                        !zamen.isEmpty &&
                        ($session.get('CustCode') == '259' ||
                          $session.get('CustCode') == '8002')
                      "
                      type="button"
                      class="loan-followup-zamen-edit-btn"
                      title="ویرایش ضامن"
                      aria-label="ویرایش ضامن"
                      @click="
                        EditZamen(
                          zamen.zamenNoId,
                          item.id,
                          zamen.name,
                          item.isModirTaeed,
                          zamen.status,
                        )
                      "
                    >
                      <i class="fa fa-pen" aria-hidden="true"></i>
                    </button>
                  </li>
                </ul>
              </section>

              <section class="loan-followup-section">
                <h6 class="loan-followup-section__title">
                  <i class="fas fa-comment-dots" aria-hidden="true"></i>
                  شرح اصلاحات کارشناس
                  {{ $GetIsAnbohSaz() == "false" ? "تسهیلات" : "قرارداد" }}
                </h6>
                <p
                  class="loan-followup-notes"
                  :class="{
                    'loan-followup-notes--empty': !hasCorrectionNote(item),
                  }"
                >
                  {{
                    hasCorrectionNote(item)
                      ? item.sharhEslahatByModir
                      : "اصلاحی ثبت نشده است"
                  }}
                </p>
              </section>
            </div>
          </article>
        </div>

        <div v-else-if="!loadingRender" class="loan-followup-empty">
          <span class="loan-followup-empty__icon" aria-hidden="true">
            <i class="fas fa-inbox"></i>
          </span>
          <span>درخواستی برای نمایش وجود ندارد</span>
        </div>
      </div>
      </template>
    </net-pa-card>

    <button
      type="button"
      class="d-none"
      id="ShowModal"
      data-toggle="modal"
      data-target="#Modal-light"
    ></button>

    <modal-custom>
      <template v-slot:ContentModalLight>
        <div class="loan-followup-modal">
          <div class="btn-Close-Modal">
            <button
              type="button"
              id="CloseModal"
              class="close text-dark"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="loan-followup-notice">
            <i class="fas fa-info-circle" aria-hidden="true"></i>
            <div>
              <div>
                کد ملی ضامن جدید را وارد و سپس روی دکمه استعلام کلیک کنید
              </div>
              <b class="loan-followup-notice__strong">
                اطلاعات ضامن جدید جایگزین {{ OldZamen.OldZamenName }} می‌شود
              </b>
            </div>
          </div>
          <div class="loan-followup-modal__input-group">
            <input
              class="form-control loan-followup-modal__input"
              placeholder="کد ملی ضامن"
              v-model="newCodemeli"
              dir="ltr"
            />
            <button
              type="button"
              class="loan-followup-modal__check-btn"
              @click="Estelam"
            >
              استعلام
            </button>
          </div>
          <div v-if="newZamenInfo != null" class="loan-followup-modal__result">
            <div class="loan-followup-modal__result-info">
              <span class="loan-followup-modal__result-label">اطلاعات ضامن</span>
              <span class="loan-followup-modal__result-name">{{
                newZamenInfo.nameFamily
              }}</span>
            </div>
            <div class="loan-followup-modal__result-actions">
              <button
                type="button"
                class="loan-followup-btn loan-followup-btn--ghost"
                @click="reject"
              >
                حذف
              </button>
              <button
                type="button"
                class="loan-followup-btn loan-followup-btn--primary"
                @click="addZamen"
              >
                تایید
              </button>
            </div>
          </div>
        </div>
      </template>
    </modal-custom>
  </div>
</template>

<script>
import ModalCustom from "../Tools/ModalCustom.vue";
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import Loading from "../Tools/NetPa/Loading.vue";

export default {
  components: { NetPaCard, Panel, ModalCustom, Loading },
  data() {
    return {
      loadingRender: false,
      loanFollowup: "loanFollowup",
      NeedVamList: [],
      newCodemeli: null,
      newZamenInfo: null,
      OldZamen: {},
      Render: 0,
      expandedDetails: {},
    };
  },
  mounted() {
    this.GetData();
  },
  methods: {
    GetData() {
      this.loadingRender = true;
      var formdata = new FormData();
      formdata.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      var DataAxiosNeedVam = {
        ArryfildValue: formdata,
        Method: "Post",
        Action: "ListNeedVam",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxiosNeedVam).then((data) => {
        this.NeedVamList = data;
        this.loadingRender = false;
      });
    },
    isExpanded(index) {
      return !!this.expandedDetails[index];
    },
    toggleDetails(index) {
      this.$set(this.expandedDetails, index, !this.expandedDetails[index]);
    },
    statusClass(item) {
      const custCode = this.$session.get("CustCode");
      if (custCode == "932" || custCode == "8002") return "";
      if (item.isModirTaeed == 0) return "loan-followup-card--warning";
      if (item.isModirTaeed == 1) return "loan-followup-card--success";
      if (item.isModirTaeed == 2) return "loan-followup-card--danger";
      return "";
    },
    hasCorrectionNote(item) {
      return (
        item.sharhEslahatByModir != null && item.sharhEslahatByModir !== ""
      );
    },
    hasExpandableDetails(item) {
      if (this.$session.get("CustCode") != 932) {
        return true;
      }
      return this.hasCorrectionNote(item);
    },
    getZamenEntries(item) {
      const configs = [
        { key: "zamenName1", status: "zamenIsTaeed1", num: 1, id: 4031 },
        { key: "zamenName2", status: "zamenIsTaeed2", num: 2, id: 4032 },
        { key: "zamenName3", status: "zamenIsTaeed3", num: 3, id: 4033 },
      ];
      return configs
        .filter((c) => item[c.key] != null)
        .map((c) => ({
          num: c.num,
          name: item[c.key],
          status: item[c.status],
          zamenNoId: c.id,
          isEmpty: item[c.key] === "",
        }));
    },
    EditZamen(ZamenNoId, NeedVamId, OldZamenName, IsModirTaeed, ZamenIsTaeed) {
      if (ZamenIsTaeed == 1) {
        this.$mySweetDefaultTost(
          "خطا در ویرایش ضامن",
          "ضامن انتخابی درخواست ضمانت شمارا تایید کرده و امکان ویرایش این ضامن وجود ندارد ",
          "error",
          2200,
        );
        return;
      }
      if (IsModirTaeed != 0) {
        this.$mySweetDefaultTost(
          "خطا در ویرایش ضامن",
          "به دلیل برسی توسط مدیر سامانه و تغییر در وضعیت درخواست امکان ویرایش ضامن وجود ندارد ",
          "error",
          2200,
        );
        return;
      }
      this.OldZamen = {
        NeedVamId: NeedVamId,
        ZamenNoId: ZamenNoId,
        OldZamenName: OldZamenName,
      };
      document.getElementById("ShowModal").click();
    },
    Estelam() {
      if (
        this.$session.get("UserInfoNetPa").codeMeli.trim() == this.newCodemeli
      ) {
        this.$mySweetDefault(
          "خطا",
          "شما کد ملی خود را وارد کرده اید",
          "error",
          2000,
        );
        this.newCodemeli = null;
        return;
      }
      if (
        this.newCodemeli.trim().length < 10 ||
        this.newCodemeli.trim().length > 10
      ) {
        this.$mySweetDefault(
          "خطا",
          " طول کد ملی نمیتواند کمتر یا بیشتر از 10 رقم باشد",
          "error",
          2000,
        );
        return;
      }
      var DataAxiosGetZament = {
        ArryfildValue: "",
        Method: "Post",
        Action: "GetZamenByMelli3Onlione",
        Token: this.$session.get("TokenNetPa"),
      };
      var formdata = new FormData();
      formdata.append(
        "wwwtblShobeId",
        this.$session.get("UserInfoNetPa").wwwtblShobeId,
      );
      formdata.append("CodeMeli", this.newCodemeli);
      DataAxiosGetZament.ArryfildValue = formdata;
      this.$PostFormData(DataAxiosGetZament).then((res) => {
        this.newZamenInfo = res;
      });
    },
    reject() {
      this.newZamenInfo = null;
      this.newCodemeli = null;
    },
    addZamen() {
      var DataAxiosNewZament = {
        ArryfildValue: "",
        Method: "Post",
        Action: "UpdateZamenByMelli",
        Token: this.$session.get("TokenNetPa"),
      };
      var formdata = new FormData();
      formdata.append("NeedVamId", this.OldZamen.NeedVamId);
      formdata.append("tblComboIdNoe10", this.OldZamen.ZamenNoId);
      formdata.append("NewCodeMeli", this.newCodemeli);
      formdata.append("NewMobile", this.newZamenInfo.mobile);
      formdata.append("NewAzaId", this.newZamenInfo.id);
      formdata.append("NewNameFamily", this.newZamenInfo.nameFamily);
      DataAxiosNewZament.ArryfildValue = formdata;
      this.$PostFormData(DataAxiosNewZament).then((res) => {
        if (res.status == "Ok") {
          this.GetData();
          document.getElementById("CloseModal").click();
          this.$mySweetDefault(
            "عملیات موفق",
            "عملیات ویرایش ضامن با موفقیت انجام شد",
            "success",
            2000,
          );
          this.Render++;
        } else {
          this.GetData();
          document.getElementById("CloseModal").click();
          this.$mySweetDefault(
            "عملیات ناموفق",
            " خطایی در ویرایش اطلاعات ضامن به  وجود آمد، لطفا دقایقی دیگر مجدد اقدام کنید",
            "error",
            2000,
          );
          this.Render++;
        }
      });
    },
  },
};
</script>

<style scoped>
.loan-followup-content {
  --lf-navy: #29345f;
  --lf-text: #13243a;
  --lf-muted: #6b7b8e;
  --lf-border: #dbe5eb;
  --lf-border-subtle: #e8eef2;
  --lf-warning: #c48726;
  --lf-success: #05a895;
  --lf-danger: #b44f46;
  --lf-info: #287db4;
  --lf-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);

  width: 100%;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
}

.loan-followup-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  box-sizing: border-box;
}

/* ---------- request item: flat row inside the page card, no extra box ---------- */
.loan-followup-card {
  --lf-accent: var(--lf-info);

  overflow: hidden;
  border: 0;
  border-bottom: 1px solid var(--lf-border-subtle);
  border-radius: 0;
  background: transparent;
}

.loan-followup-card:last-child {
  border-bottom: 0;
}

.loan-followup-card--warning {
  --lf-accent: var(--lf-warning);
}

.loan-followup-card--success {
  --lf-accent: var(--lf-success);
}

.loan-followup-card--danger {
  --lf-accent: var(--lf-danger);
}

.loan-followup-card__top {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.6rem 1rem 0;
  direction: rtl;
}

.loan-followup-card__tracking {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 0.5rem;
  min-width: 0;
}

.loan-followup-card__tracking-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--lf-muted);
}

.loan-followup-card__tracking-code {
  font-size: 1.1rem;
  font-weight: 800;
  line-height: 1.3;
  color: var(--lf-navy);
  direction: ltr;
  unicode-bidi: isolate;
}

.loan-followup-card__status {
  flex-shrink: 0;
}

.loan-followup-card__body {
  padding: 0.25rem 1rem 0.5rem;
  text-align: right;
}

.loan-followup-card__type {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35rem;
}

.loan-followup-card__eyebrow {
  font-size: 12px;
  color: var(--lf-muted);
}

.loan-followup-card__eyebrow::after {
  content: ":";
}

.loan-followup-card__title {
  margin: 0;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.6;
  color: var(--lf-navy);
  word-break: break-word;
}

.loan-followup-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 2rem;
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px dashed var(--lf-border);
}

.loan-followup-stat {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
}

.loan-followup-stat__label {
  font-size: 12px;
  color: var(--lf-muted);
}

.loan-followup-stat__value {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.5;
  color: var(--lf-text);
  unicode-bidi: isolate;
  word-break: break-word;
}

.loan-followup-stat__value small {
  margin-right: 2px;
  font-size: 11px;
  font-weight: 500;
  color: #8091a3;
}

/* ---------- status badges ---------- */
.loan-followup-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.2rem 0.65rem;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
  white-space: nowrap;
}

.loan-followup-badge i {
  font-size: 11px;
}

.loan-followup-badge--warning {
  background: #fff7e8;
  color: #9a6a18;
}

.loan-followup-badge--success {
  background: #e6f6f3;
  color: #047a6b;
}

.loan-followup-badge--danger {
  background: #fcefed;
  color: var(--lf-danger);
}

.loan-followup-badge--info {
  background: #edf5fb;
  color: #1f6495;
}

/* ---------- details toggle ---------- */
.loan-followup-toggle-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  width: 100%;
  padding: 0.25rem 1rem 0.5rem;
  border: 0;
  background: transparent;
  color: var(--lf-info);
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.18s ease;
}

.loan-followup-toggle-btn i {
  font-size: 11px;
}

.loan-followup-toggle-btn:hover {
  background: #f4f8fb;
}

.loan-followup-toggle-btn:focus {
  outline: none;
}

.loan-followup-toggle-btn:focus-visible {
  box-shadow: inset 0 0 0 2px #05b8c8;
}

/* ---------- details ---------- */
.loan-followup-details {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  padding: 0.8rem 1rem 0.9rem;
  background: #f9fbfc;
}

.loan-followup-section__title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 0.65rem;
  font-size: 13px;
  font-weight: 800;
  color: var(--lf-navy);
  text-align: right;
}

.loan-followup-section__title i {
  font-size: 12px;
  color: var(--lf-info);
}

.loan-followup-zamen-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.loan-followup-zamen-row {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  padding: 0.55rem 0.8rem;
  border: 0;
  border-radius: 12px;
  background: #fff;
  direction: rtl;
}

.loan-followup-zamen-row__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: linear-gradient(145deg, #05b8c8, #8d58a4);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.loan-followup-zamen-row__name {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13px;
  font-weight: 700;
  color: var(--lf-navy);
  word-break: break-word;
  text-align: right;
}

.loan-followup-zamen-row__name--muted,
.loan-followup-zamen-row__muted {
  color: var(--lf-muted);
  font-weight: 500;
}

.loan-followup-zamen-edit-btn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 10px;
  background: #f4f7f9;
  color: var(--lf-navy);
  font-size: 12px;
  cursor: pointer;
  transition: background 0.18s ease;
}

.loan-followup-zamen-edit-btn:hover {
  background: #e6edf1;
}

.loan-followup-zamen-edit-btn:focus {
  outline: none;
}

.loan-followup-zamen-edit-btn:focus-visible {
  box-shadow: var(--lf-focus-ring);
}

.loan-followup-notes {
  margin: 0;
  padding: 0.8rem 1rem;
  border: 0;
  border-radius: 12px;
  background: #fff;
  color: #3b4a5c;
  font-size: 13px;
  line-height: 1.9;
  text-align: right;
  white-space: pre-wrap;
  word-break: break-word;
}

.loan-followup-notes--empty {
  color: var(--lf-muted);
}

/* ---------- empty state ---------- */
.loan-followup-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.85rem;
  min-height: 12rem;
  padding: 1.5rem;
  color: var(--lf-muted);
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}

.loan-followup-empty__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: #edf7fb;
  color: var(--lf-info);
  font-size: 22px;
}

/* ---------- modal ---------- */
.loan-followup-modal {
  padding: 0.5rem;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
}

.loan-followup-notice {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  padding: 0.8rem 1rem;
  border: 1px solid #f3e3c4;
  border-right: 3px solid #c48726;
  border-radius: 14px;
  background: #fff9ee;
  color: #3b4a5c;
  font-size: 13px;
  line-height: 1.9;
  text-align: right;
}

.loan-followup-notice > i {
  flex-shrink: 0;
  margin-top: 0.4rem;
  color: #c48726;
}

.loan-followup-notice__strong {
  display: block;
  margin-top: 0.25rem;
  color: #b44f46;
}

.loan-followup-modal__input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 42px;
  margin-top: 1rem;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  direction: rtl;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.loan-followup-modal__input-group:hover {
  border-color: #bdcbd4;
}

.loan-followup-modal__input-group:focus-within {
  border-color: #05b8c8;
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

.loan-followup-modal__input {
  flex: 1 1 auto;
  min-width: 0;
  height: 100% !important;
  padding: 0 0.85rem !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  font-size: 13px;
  text-align: left;
}

.loan-followup-modal__check-btn {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 5rem;
  padding: 0 1rem;
  border: none;
  border-right: 1px solid #dbe5eb;
  border-radius: 0;
  background: #edf7fb;
  color: #29345f;
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.18s ease;
}

.loan-followup-modal__check-btn:hover {
  background: #dcf0f6;
}

.loan-followup-modal__check-btn:focus {
  outline: none;
}

.loan-followup-modal__check-btn:focus-visible {
  box-shadow: inset 0 0 0 2px #05b8c8;
}

.loan-followup-modal__result {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 1rem;
  padding: 0.8rem 1rem;
  border: 1px solid rgba(5, 168, 149, 0.25);
  border-radius: 14px;
  background: #f3fbf9;
  direction: rtl;
}

.loan-followup-modal__result-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
  text-align: right;
}

.loan-followup-modal__result-label {
  font-size: 12px;
  color: #6b7b8e;
}

.loan-followup-modal__result-name {
  font-size: 14px;
  font-weight: 800;
  color: #29345f;
  word-break: break-word;
}

.loan-followup-modal__result-actions {
  display: flex;
  gap: 0.5rem;
}

.loan-followup-btn {
  min-width: 5rem;
  min-height: 38px;
  padding: 0 1.1rem;
  border: 1px solid transparent;
  border-radius: 12px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease,
    background-color 0.18s ease;
}

.loan-followup-btn:focus {
  outline: none;
}

.loan-followup-btn:focus-visible {
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

.loan-followup-btn--ghost {
  background: #fff;
  border-color: #dbe5eb;
  color: #29345f;
}

.loan-followup-btn--ghost:hover {
  background: #f4f7f9;
  border-color: #bdcbd4;
}

.loan-followup-btn--primary {
  background: linear-gradient(110deg, #29345f, #56508d 58%, #8d58a4);
  color: #fff;
  box-shadow: 0 6px 14px rgba(41, 52, 95, 0.2);
}

.loan-followup-btn--primary:hover {
  transform: translateY(-2px);
}

@media (prefers-reduced-motion: reduce) {
  .loan-followup-card,
  .loan-followup-btn,
  .loan-followup-modal__input-group {
    transition: none;
  }

  .loan-followup-btn--primary:hover {
    transform: none;
  }
}

@media (max-width: 575px) {
  .loan-followup-list {
    padding: 0;
  }

  .loan-followup-card__top,
  .loan-followup-card__body,
  .loan-followup-details {
    padding-right: 0.75rem;
    padding-left: 0.75rem;
  }
}
</style>
